import IAuthorizationData from "../server/data/IAuthorizationData";
import { IBaseDataParser } from "../server/parsers/IBaseDataParser";
import Utils from "../../src/utils/Utils";

export abstract class BaseModel<T> {
    protected parsers: IBaseDataParser<T>[];
    protected processedData: T[];

    public registerParser(parser: IBaseDataParser<T>) {
        if (!this.parsers) {
            this.parsers = [];
        }
        this.parsers.push(parser);
    }

    public setDefaults(data: T) {
        this.assign(data);
    }

    public update(data?: any) {
            console.log('additionalLog BaseModel.update(): ', data);
        
        let processedData = this.processData(data);
        if (processedData.length || data) {
            this.processedData = processedData;
        }
        // try {
        while (this.processedData && this.processedData.length > 0) {
            this.assign(this.processedData.shift());
        }
        // } catch (e) {
        //     throw new Error(("No available data"));
        // }
        // processedData.forEach(key => {
        //     this.assign(key);
        // });
    }

    protected assign(processedData: T) {
        Utils.serialize(processedData, this);
    }

    protected processData(data): T[] {
        const results: T[] = [];
        if (this.parsers) {
            for (let parser = 0; parser < this.parsers.length; parser++) {
                if (this.parsers[parser].check(data)) {
                    let result = this.parsers[parser].parse(data);
                    if (Array.isArray(result)) {
                        results.push(...result);
                    } else {
                        results.push(result);
                    }
                }
            }
            return results;
        } else {
            throw new Error("No Parser found for supplied data");
        }
    }

    public serialize(data, object) {
        if (!data) {
            return;
        }

        Object.keys(data).forEach((key) => {
            if (object.hasOwnProperty(key)) {
                object[key] = data[key];
            }
        });
    }
}
